import EliminatedPath from 'app/assets/ppm/32/PPM_LifecycleStage_Eliminated_32.png';
import GrowthPath from 'app/assets/ppm/32/PPM_LifecycleStage_Growth_32.png';
import IntroductionPath from 'app/assets/ppm/32/PPM_LifecycleStage_Introduction_32.png';
import NotAvailablePath from 'app/assets/ppm/32/PPM_LifecycleStage_NotAvailable_32.png';
import NotUsedInCountryPath from 'app/assets/ppm/32/PPM_LifecycleStage_NotUsedInCountry_32.png';
import OccasionalUsePath from 'app/assets/ppm/32/PPM_LifecycleStage_OccasionalUse_32.png';
import PhaseOutPath from 'app/assets/ppm/32/PPM_LifecycleStage_PhaseOut_32.png';
import UndefinedPath from 'app/assets/ppm/32/PPM_LifecycleStage_Undefined_32.png';

export const ppmIconLarge = {
    E: EliminatedPath,
    G: GrowthPath,
    I: IntroductionPath,
    NA: NotAvailablePath,
    N: NotUsedInCountryPath,
    O: OccasionalUsePath,
    P: PhaseOutPath,
    U: UndefinedPath
};
